module.exports = __webpack_public_path__ + "img/bulle-error.7c70e010.png";